import React from "react";
import styled from "styled-components";
import Header from "../Header";
import Footer from "../Footer";

const ContentWrapper = styled.main`
  /* adjust based on header height */
  background-color: #000;
  color: #fff;
`;

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <ContentWrapper>{children}</ContentWrapper>
      <Footer />
    </>
  );
};

export default Layout;
